import {
  DISPOSITIVOPACIENTE_ERROR,
  DISPOSITIVOPACIENTE_LOADING,
  DISPOSITIVOPACIENTE_RESET,
  DISPOSITIVOPACIENTE_SUCCESS,
  DISPOSITIVOPACIENTEDELETE_LOADING,
  DISPOSITIVOPACIENTEDELETE_SUCCESS,
  DISPOSITIVOPACIENTEDELETE_ERROR,
  DISPOSITIVOPACIENTEAGREGAR_LOADING,
  DISPOSITIVOPACIENTEAGREGAR_SUCCESS,
  DISPOSITIVOPACIENTEAGREGAR_ERROR,
  DISPOSITIVOPACIENTE_FLGVINCULADO,
  DISPOSITIVOPACIENTEDELETE_RESET,
  DISPOSITIVOPACIENTEAGREGAR_RESET,
  DISPOSITIVOPACIENTETRANSFERIR_LOADING,
  DISPOSITIVOPACIENTETRANSFERIR_SUCCESS,
  DISPOSITIVOPACIENTETRANSFERIR_ERROR,
  DISPOSITIVOPACIENTETRANSFERIR_RESET,
  DISPOSITIVOPACIENTEPREFERENCIAS_LOADING,
  DISPOSITIVOPACIENTEPREFERENCIAS_SUCCESS,
  DISPOSITIVOPACIENTEPREFERENCIAS_ERROR,
  DISPOSITIVOPACIENTEPREFERENCIAS_RESET,
  RESET_PORTAL_CONTEXT
} from "../ActionTypes";

import dispositivoPacienteInitialState from "../initialStates/dispositivoPacienteInitialState";

const dispositivoPaciente = (state, { payload, type }) => {
  switch (type) {
    case DISPOSITIVOPACIENTE_LOADING:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: false,
          loading: true,
        },
      };
    case DISPOSITIVOPACIENTE_SUCCESS:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case DISPOSITIVOPACIENTE_ERROR:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: payload,
          loading: false,
        },
      };

    case DISPOSITIVOPACIENTEDELETE_LOADING:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: false,
          loading: true,
        },
      };
    case DISPOSITIVOPACIENTEDELETE_SUCCESS:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          loading: false,
          error: false,
          delete: payload,
        },
      };
      case DISPOSITIVOPACIENTEDELETE_ERROR:
        return {
          ...state,
          dispositivoPaciente: {
            ...state.dispositivoPaciente,
            error: payload,
            loading: false,
          },
        };
        case DISPOSITIVOPACIENTEDELETE_RESET:
          return {
            ...state,
            dispositivoPaciente: {
              ...state.dispositivoPaciente,
              delete: false,
            },
          };

    case DISPOSITIVOPACIENTEAGREGAR_LOADING:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: false,
          loading: true,
        },
      };
    case DISPOSITIVOPACIENTEAGREGAR_SUCCESS:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          loading: false,
          error: false,
          post: payload,
        },
      };
    case DISPOSITIVOPACIENTEAGREGAR_RESET:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          post: false,
        },
      };
    case DISPOSITIVOPACIENTEAGREGAR_ERROR:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          error: payload,
          loading: false,
        },
      };

    case DISPOSITIVOPACIENTETRANSFERIR_LOADING:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          transferir: { loading: true, data: null, error: null },
        },
      };
    case DISPOSITIVOPACIENTETRANSFERIR_SUCCESS:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          transferir: { loading: false, data: payload, error: null },
        },
      };
    case DISPOSITIVOPACIENTETRANSFERIR_ERROR:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          transferir: { loading: false, data: null, error: payload },
        },
      };
    case DISPOSITIVOPACIENTETRANSFERIR_RESET:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          transferir: null,
        },
      };

    case DISPOSITIVOPACIENTEPREFERENCIAS_LOADING:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          preferencias: { loading: true, data: null, error: null },
        },
      };
    case DISPOSITIVOPACIENTEPREFERENCIAS_SUCCESS:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          // Actualizamos el data del dispositivo con la respuesta (que
          // ahora incluye notificacionesActivas actualizado).
          data: payload || state.dispositivoPaciente.data,
          preferencias: { loading: false, data: payload, error: null },
        },
      };
    case DISPOSITIVOPACIENTEPREFERENCIAS_ERROR:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          preferencias: { loading: false, data: null, error: payload },
        },
      };
    case DISPOSITIVOPACIENTEPREFERENCIAS_RESET:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          preferencias: null,
        },
      };

    case DISPOSITIVOPACIENTE_FLGVINCULADO:
      return {
        ...state,
        dispositivoPaciente: {
          ...state.dispositivoPaciente,
          flgVinculado: true,
         
        },
      };

    case DISPOSITIVOPACIENTE_RESET:
      return dispositivoPacienteInitialState;
      
    case RESET_PORTAL_CONTEXT:
      return dispositivoPacienteInitialState;

    default:
      return state;
  }
};

export default dispositivoPaciente;
